import { render, staticRenderFns } from "./mxstrtag.vue?vue&type=template&id=3460b9b4&scoped=true"
import script from "./mxstrtag.vue?vue&type=script&lang=js"
export * from "./mxstrtag.vue?vue&type=script&lang=js"
import style0 from "./mxstrtag.vue?vue&type=style&index=0&id=3460b9b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460b9b4",
  null
  
)

export default component.exports